/* eslint-disable no-self-assign */
import {Component, Vue} from 'vue-property-decorator'
import * as echarts from 'echarts';

import {
    lastMonth,
    lastQuarter,
    lastWeek,
    lastYear,
    thisMonth,
    thisQuarter,
    thisWeek,
    thisYear,
    thisYesterday,
    thisToday
} from "@/utils/dateTime";
import {Loading} from "element-ui";
import {delNullProperty} from "@/utils";
import commonData from "@/utils/commonData";
import {getClassesStaticData} from "@/api/classManage";

@Component({})
export default class StatisticsData extends Vue {
    // ------ data ------
    dataFilter = 0
    channelAllnum = 0 // 渠道总量
    signAllnum = 0 // 签约总量
    clueReceiverAllnum = 0 // 下发总量
    clueAllnum = 0 // 线索总量
    timeStr = ''
    timeType = '1'
    startWeek = '' // 本周开始
    endWeek = '' //本周结束
    startMonth = '' // 本月开始
    endMonth = ''  //本月结束
    startLastWeek = '' //上周开始
    endLastWeek = '' //上周结束
    startLastMonth = '' // 上月开始
    endLastMonth = ''  // 上月结束
    startQuarter = ''  // 本季度开始
    endQuarter = '' // 本季度结束
    startLastQuarter = '' //上季度开始
    endLastQuarter = '' //上季度结束
    startYear = '' // 本年开始
    endYear = '' // 本年结束
    timeStrDate = []
    today = ''
    yesterday = ''
    yesteryearStart = ''
    yesteryearEnd = ''
    resultList = []
    resultStaticalList = []
    // recordId: string = ''
    // recordName: string = ''
    // marketChannelAllSelectDataName: string = ''
    souCourseTypeId = 1 // 项目类型
    typeList = commonData.projectTypeArray
    dateStr = ''
    queryData = []
    loadingTable1 = false
    loadingTable2 = false
    loadingTable3 = false
    loadingTable4 = false
    loadingTable5 = false
    loadingTable6 = false
    tableData1 = []
    tableData2 = []
    tableData3 = []
    tableData4 = []
    tableData5 = []
    tableData6 = []

    // ------ 生命周期 ------
    created() {

        this.getDateInterval()
    }


    // ------ 方法 ------
    // changeRadio() {
    //     this.getData()
    // }
    /*
    * 改变项目类型*/
    changeSouCourseType(val) {
        this.souCourseTypeId = val
        this.getData()
    }

    getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
            if (index === 0) {
                sums[index] = '合计';
                return;
            }
            const values = data.map(item => Number(item[column.property]));
            if (column.property != 'marketClueLevel1Ratio' && column.property != 'marketClueLevel2Ratio' && column.property != 'marketClueLevel3Ratio' && column.property != 'marketClueLevel4Ratio') {
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0)
                }
            } else if (column.property == 'marketClueLevel1Ratio') {
                let sum1 = 0
                let sum2 = 0
                data.forEach(item => {
                    sum1 += Number(item.marketClueLevel1Count + item.marketClueLevel2Count + item.marketClueLevel3Count + item.marketClueLevel4Count)   // 总计各咨询部
                    sum2 += Number(item.marketClueLevel1Count)  // 一级数量总
                })
                let finalVal = 0

                if (sum1 !== 0 && sum2 !== 0) {
                    finalVal = Math.round(sum2 / sum1 * 100)
                    sums[index] = finalVal + '%'
                } else {
                    sums[index] = Number(0)
                }
            } else if (column.property == 'marketClueLevel2Ratio') {
                let sum1 = 0
                let sum2 = 0
                data.forEach(item => {
                    sum1 += Number(item.marketClueLevel1Count + item.marketClueLevel2Count + item.marketClueLevel3Count + item.marketClueLevel4Count)   // 总计各咨询部
                    sum2 += Number(item.marketClueLevel2Count)  // 一级数量总
                })
                let finalVal = 0

                if (sum1 !== 0 && sum2 !== 0) {
                    finalVal = Math.round(sum2 / sum1 * 100)
                    sums[index] = finalVal + '%'
                } else {
                    sums[index] = Number(0)
                }
            } else if (column.property == 'marketClueLevel3Ratio') {
                let sum1 = 0
                let sum2 = 0
                data.forEach(item => {
                    sum1 += Number(item.marketClueLevel1Count + item.marketClueLevel2Count + item.marketClueLevel3Count + item.marketClueLevel4Count)   // 总计各咨询部
                    sum2 += Number(item.marketClueLevel3Count)  // 一级数量总
                })
                let finalVal = 0

                if (sum1 !== 0 && sum2 !== 0) {
                    finalVal = Math.round(sum2 / sum1 * 100)
                    sums[index] = finalVal + '%'
                } else {
                    sums[index] = Number(0)
                }
            } else if (column.property == 'marketClueLevel4Ratio') {
                let sum1 = 0
                let sum2 = 0
                data.forEach(item => {
                    sum1 += Number(item.marketClueLevel1Count + item.marketClueLevel2Count + item.marketClueLevel3Count + item.marketClueLevel4Count)   // 总计各咨询部
                    sum2 += Number(item.marketClueLevel4Count)  // 一级数量总
                })
                let finalVal = 0

                if (sum1 !== 0 && sum2 !== 0) {
                    finalVal = Math.round(sum2 / sum1 * 100)
                    sums[index] = finalVal + '%'
                } else {
                    sums[index] = Number(0)
                }
            }
        })
        return sums;
    }

    // getData() {
    //
    // }

    async getData() {
        this.loadingTable1 = true
        this.loadingTable2 = true
        this.loadingTable3 = true
        this.loadingTable4 = true
        this.loadingTable5 = true
        this.loadingTable6 = true

        const obj: any = {
            timeStr: this.timeStr,
            souCourseTypeId: this.souCourseTypeId,
        }
        this.queryData = []
        const month: any = this.timeStr.split('&')[1].split('-')
        let year: any = month[0]
        let month1: any = month[1] * 1
        if (month.length) {
            for (let index = 0; index < 6; index++) {
                const obj1 = {
                    key: year + '-' + ((month1 * 1) >= 10 ? (month1) : '0' + (month1)),
                    value: null,
                    show: true
                }
                if (month1 * 1 == 12) {
                    month1 = 0
                    year++
                }
                month1++
                this.queryData.push(obj1)
            }
        }

        setTimeout(() => {
            this.queryData.forEach(async (item, index) => {
                obj.dateStr = item.key
                const {classesStatisticalData}: any = await getClassesStaticData(obj)
                if (index == 0) {
                    this.tableData1 = classesStatisticalData
                    this.loadingTable1 = false
                } else if (index == 1) {
                    this.tableData2 = classesStatisticalData
                    this.loadingTable2 = false
                } else if (index == 2) {
                    this.tableData3 = classesStatisticalData
                    this.loadingTable3 = false
                } else if (index == 3) {
                    this.tableData4 = classesStatisticalData
                    this.loadingTable4 = false
                } else if (index == 4) {
                    this.tableData5 = classesStatisticalData
                    this.loadingTable5 = false
                } else if (index == 5) {
                    this.tableData6 = classesStatisticalData
                    this.loadingTable6 = false
                }
            })
        }, 0)

    }


    // 选择区间
    changeDateType(val) {
        if (val === '2') {  //    本周
            this.timeStr = this.startWeek + '&' + this.endWeek
            this.timeStrDate = [this.startWeek, this.endWeek]
        } else if (val === '3') { // 本月
            this.timeStr = this.startMonth + '&' + this.endMonth
            this.timeStrDate = [this.startMonth, this.endMonth]
        } else if (val === '4') { // 本季度
            this.timeStr = this.startQuarter + '&' + this.endQuarter
            this.timeStrDate = [this.startQuarter, this.endQuarter]
        } else if (val === '5') { // 本年
            this.timeStr = this.startYear + '&' + this.endYear
            this.timeStrDate = [this.startYear, this.endYear]
        } else if (val === '6') { // 上周
            this.timeStr = this.startLastWeek + '&' + this.endLastWeek
            this.timeStrDate = [this.startLastWeek, this.endLastWeek]
        } else if (val === '7') { // 上月
            this.timeStr = this.startLastMonth + '&' + this.endLastMonth
            this.timeStrDate = [this.startLastMonth, this.endLastMonth]
        } else if (val === '8') { // 上季度
            this.timeStr = this.startLastQuarter + '&' + this.endLastQuarter
            this.timeStrDate = [this.startLastQuarter, this.endLastQuarter]
        } else if (val === '9') { // 去年
            this.timeStr = this.yesteryearStart + '&' + this.yesteryearEnd
            this.timeStrDate = [this.yesteryearStart, this.yesteryearEnd]
        } else if (val === '0') { // 昨天
            this.timeStr = this.yesterday + '&' + this.yesterday
            this.timeStrDate = [this.yesterday, this.yesterday]
        } else if (val === '1') { // 今天
            this.timeStr = this.today + '&' + this.today
            this.timeStrDate = [this.today, this.today]
        } else {
            this.timeStr = ''
            this.timeStrDate = []
        }

        if (this.timeStr) {
            this.getData()
        }

    }

    handleChangeData(val) {
        const week = [this.startWeek, this.endWeek]
        const month = [this.startMonth, this.endMonth]
        const year = [this.startYear, this.endYear]
        const quarter = [this.startQuarter, this.endQuarter]
        const lastWeek = [this.startLastWeek, this.endLastWeek]
        const lastMonth = [this.startLastMonth, this.endLastMonth]
        const lastQuarter = [this.startLastQuarter, this.endLastQuarter]
        const lastyear = [this.yesteryearStart, this.yesteryearEnd]
        const yesterday = [this.yesterday, this.yesterday]
        const today = [this.today, this.today]
        if (week[0].indexOf(val[0]) !== -1 && week[1].indexOf(val[1]) !== -1) {
            this.timeType = '2'
        } else if (month[0].indexOf(val[0]) !== -1 && month[1].indexOf(val[1]) !== -1) {
            this.timeType = '3'
        } else if (quarter[0].indexOf(val[0]) !== -1 && quarter[1].indexOf(val[1]) !== -1) {
            this.timeType = '4'
        } else if (year[0].indexOf(val[0]) !== -1 && year[1].indexOf(val[1]) !== -1) {
            this.timeType = '5'
        } else if (lastWeek[0].indexOf(val[0]) !== -1 && lastWeek[1].indexOf(val[1]) !== -1) {
            this.timeType = '6'
        } else if (lastMonth[0].indexOf(val[0]) !== -1 && lastMonth[1].indexOf(val[1]) !== -1) {
            this.timeType = '7'
        } else if (lastQuarter[0].indexOf(val[0]) !== -1 && lastQuarter[1].indexOf(val[1]) !== -1) {
            this.timeType = '8'
        } else if (lastyear[0].indexOf(val[0]) !== -1 && lastyear[1].indexOf(val[1]) !== -1) {
            this.timeType = '9'
        } else if (yesterday[0].indexOf(val[0]) !== -1 && yesterday[1].indexOf(val[1]) !== -1) {
            this.timeType = '0'
        } else if (today[0].indexOf(val[0]) !== -1 && today[1].indexOf(val[1]) !== -1) {
            this.timeType = '1'
        } else {
            this.timeType = '自定义时间'
        }
        this.timeStr = val[0] + '&' + val[1]
        this.getData()
    }

    //    初始化获取日期区间
    getDateInterval() {

        // 获取今天
        this.today = thisToday()

        // 获取昨天
        this.yesterday = thisYesterday()

        // 本周
        this.startWeek = thisWeek()[0]//周一日期
        this.endWeek = thisWeek()[1];//周日日期

        //上周
        this.startLastWeek = lastWeek()[0]; //周一日期
        this.endLastWeek = lastWeek()[1]; //周日日期

        // 本月
        this.startMonth = thisMonth()[0]
        this.endMonth = thisMonth()[1]

        // 上月
        this.startLastMonth = lastMonth()[0];
        this.endLastMonth = lastMonth()[1];

        // 本季度
        this.startQuarter = thisQuarter()[0];
        this.endQuarter = thisQuarter()[1];

        // 上季度
        this.startLastQuarter = lastQuarter()[0];
        this.endLastQuarter = lastQuarter()[1];

        //本年
        this.startYear = thisYear()[0];
        this.endYear = thisYear()[1];

        // 获取去年
        this.yesteryearStart = lastYear()[0];
        this.yesteryearEnd = lastYear()[1];

        if (this.timeType == '0') {
            this.timeStr = this.yesterday + '&' + this.yesterday
            this.timeStrDate = [this.yesterday, this.yesterday]
            this.getData()
        } else if (this.timeType == '1') {
            this.timeStr = this.today + '&' + this.today
            this.timeStrDate = [this.today, this.today]
            this.getData()
        }

    }


    tableRowClassName({row}) {
        if (row.isColour == true) {
            return 'warning-row';
        }
        return '';
    }
}
